let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i9qq1")).then(() => parcelRequire('2NGQG'));